import analyticsMixin from "@/mixins/analytics-mixin";

export async function afterEach(to, from) {
    // Push page view to GA
    analyticsMixin.methods.pushPageViewToGA();

    // Push experiments to Data Layer
    analyticsMixin.methods.pushExperimentsToDataLayer();

    // Push current order status to Data Layer
    analyticsMixin.methods.pushOrderToDataLayer();
}
